import {loadLib} from "../../../utils/loadLib";

let isLoaded = false;
let loadingPromise = null;

function hasFiltersOnPage() {
	return Boolean(document.querySelector('.catalog-filters') || document.querySelector('#catalog-filter-form'));
}

function loadFiltersModule() {
	if (isLoaded) {
		return Promise.resolve();
	}

	if (!loadingPromise) {
		loadingPromise = loadLib.catalogFilters().then((m) => {
			if (typeof m?.init === 'function') {
				m.init();
			}
			isLoaded = true;
		});
	}

	return loadingPromise;
}

function initCatalogFilters() {
	if (!hasFiltersOnPage()) {
		return;
	}

	loadFiltersModule();
}

document.addEventListener('DOMContentLoaded', initCatalogFilters);
typeof onTurboRender !== 'undefined' && onTurboRender(() => initCatalogFilters());
